module.exports = "<p>\n  abrechnungsform works!\n</p>\n"